import React from "react";

import { Link } from "react-router-dom";

import { Header } from "./Header";

interface PageLayoutProps {
  /** Optional page title displayed next to the logo */
  title?: string;
  children: React.ReactNode;
}

/**
 * Common page layout with header navigation and footer
 */
export const PageLayout: React.FC<PageLayoutProps> = ({
  title = import.meta.env.VITE_APP_NAME,
  children,
}) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header title={title} />
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-4 md:py-4">
        {children}
      </main>
      <footer className="border-t py-6">
        <div className="container flex flex-col md:flex-row items-center justify-between gap-4  mx-auto px-4">
          <p className="text-sm text-muted-foreground">
            © 2025 {import.meta.env.VITE_APP_NAME}. All rights reserved.
          </p>
          <div className="flex gap-4">
            <Link
              to="/terms"
              className="text-sm text-muted-foreground hover:underline"
            >
              Terms of Use
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:underline"
            >
              Privacy Policy
            </Link>
            <Link
              to="/about"
              className="text-sm text-muted-foreground hover:underline"
            >
              About
            </Link>
            <Link
              to="/about-us"
              className="text-sm text-muted-foreground hover:underline"
            >
              About Us
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
